// Demo data for Lodge & Co — all fictional, for visual demonstration only.

// Phase 3D.1-B3 — canonical explicit provenance metadata for the synthetic demo
// layer. This is the SINGLE source of the five explicit fields consumed by the
// B2 ProvenanceBadges component. Never inferred; historical synthetic observations
// are is_demo=true / simulation=false (SIMULATION is reserved for future projections).
export const DEMO_META = {
  is_demo: true,
  provenance: "synthetic_demo",
  provenance_label: "DONNÉES DE DÉMONSTRATION",
  affiliation: "none",
  simulation: false,
};


export const WORKSPACES = [
  { id: "smb", name: "Destination Savoie Mont-Blanc", type: "Office de tourisme" },
  { id: "royal", name: "Royal Lodge Collection", type: "Collection hôtelière" },
  { id: "airlink", name: "AirLink Alpine", type: "Compagnie aérienne" },
];

export const CURRENT_USER = {
  name: "Camille Laurent",
  initials: "CL",
  email: "camille.laurent@lodgeandco.io",
};

// ---- Dashboard ----
export const KPIS = [
  {
    id: "visibility",
    labelKey: "kpi_visibility",
    value: "84.2",
    unit: "/100",
    delta: "+6.4",
    positive: true,
    hint: "vs. période préc.",
  },
  {
    id: "demand",
    labelKey: "kpi_demand",
    value: "1.28",
    unit: "M",
    delta: "+12.1%",
    positive: true,
    hint: "recherches pondérées",
  },
  {
    id: "opportunities",
    labelKey: "kpi_opportunities",
    value: "27",
    unit: "",
    delta: "+5",
    positive: true,
    hint: "nouvelles cette semaine",
  },
  {
    id: "conversion",
    labelKey: "kpi_conversion",
    value: "31.6",
    unit: "%",
    delta: "-1.2%",
    positive: false,
    hint: "leads → activation",
  },
];

export const DEMAND_SERIES = [
  { month: "Jan", demand: 62, forecast: 60 },
  { month: "Fév", demand: 68, forecast: 66 },
  { month: "Mar", demand: 74, forecast: 72 },
  { month: "Avr", demand: 71, forecast: 73 },
  { month: "Mai", demand: 83, forecast: 80 },
  { month: "Juin", demand: 92, forecast: 88 },
  { month: "Juil", demand: 100, forecast: 95 },
  { month: "Aoû", demand: 97, forecast: 96 },
  { month: "Sep", demand: 85, forecast: 87 },
  { month: "Oct", demand: 79, forecast: 78 },
  { month: "Nov", demand: 74, forecast: 72 },
  { month: "Déc", demand: 90, forecast: 84 },
];

export const TOP_MARKETS_BARS = [
  { name: "États-Unis", value: 22 },
  { name: "Royaume-Uni", value: 18 },
  { name: "Allemagne", value: 15 },
  { name: "Émirats A.U.", value: 11 },
  { name: "Brésil", value: 9 },
  { name: "Japon", value: 7 },
];

export const CHANNELS = [
  { name: "Direct", value: 38, color: "#1E3D2B" },
  { name: "OTA", value: 27, color: "#478060" },
  { name: "DMC", value: 19, color: "#0D9488" },
  { name: "Aérien", value: 16, color: "#D97706" },
];

export const AI_SIGNALS = [
  {
    id: 1,
    title: "Pic de demande US détecté sur le segment luxe hiver",
    tag: "Marché",
    time: "il y a 2 h",
    tone: "blue",
  },
  {
    id: 2,
    title: "Écart tarifaire favorable vs. destinations concurrentes (Alpes CH)",
    tag: "Pricing",
    time: "il y a 5 h",
    tone: "amber",
  },
  {
    id: 3,
    title: "Nouveau partenaire DMC compatible avec vos lodges premium",
    tag: "Partenaire",
    time: "il y a 1 j",
    tone: "green",
  },
  {
    id: 4,
    title: "Fenêtre de réservation optimale : booking window à J-45",
    tag: "Timing",
    time: "il y a 1 j",
    tone: "blue",
  },
];

// ---- Markets ----
export const MARKETS = [
  { id: "us", flag: "🇺🇸", country: "États-Unis", region: "Amérique du Nord", demand: 100, trend: [60, 66, 70, 74, 80, 88, 100], growth: 12.4, spend: "4 820 €", maturity: "Mature" },
  { id: "uk", flag: "🇬🇧", country: "Royaume-Uni", region: "Europe", demand: 88, trend: [70, 72, 71, 75, 80, 84, 88], growth: 5.1, spend: "3 140 €", maturity: "Mature" },
  { id: "de", flag: "🇩🇪", country: "Allemagne", region: "Europe", demand: 81, trend: [66, 68, 70, 72, 74, 78, 81], growth: 3.9, spend: "2 760 €", maturity: "Mature" },
  { id: "ae", flag: "🇦🇪", country: "Émirats A.U.", region: "Moyen-Orient", demand: 74, trend: [40, 48, 55, 60, 66, 70, 74], growth: 24.8, spend: "7 950 €", maturity: "Émergent" },
  { id: "br", flag: "🇧🇷", country: "Brésil", region: "Amérique du Sud", demand: 63, trend: [30, 36, 44, 50, 55, 59, 63], growth: 18.2, spend: "3 480 €", maturity: "Émergent" },
  { id: "jp", flag: "🇯🇵", country: "Japon", region: "Asie-Pacifique", demand: 58, trend: [52, 54, 53, 55, 56, 57, 58], growth: 2.3, spend: "4 210 €", maturity: "Mature" },
  { id: "in", flag: "🇮🇳", country: "Inde", region: "Asie-Pacifique", demand: 51, trend: [22, 28, 34, 40, 45, 48, 51], growth: 31.5, spend: "2 980 €", maturity: "En forte croissance" },
  { id: "cn", flag: "🇨🇳", country: "Chine", region: "Asie-Pacifique", demand: 49, trend: [38, 34, 36, 40, 44, 47, 49], growth: 9.7, spend: "5 620 €", maturity: "En reprise" },
  { id: "ca", flag: "🇨🇦", country: "Canada", region: "Amérique du Nord", demand: 46, trend: [40, 41, 42, 43, 44, 45, 46], growth: 4.4, spend: "3 010 €", maturity: "Mature" },
  { id: "au", flag: "🇦🇺", country: "Australie", region: "Asie-Pacifique", demand: 39, trend: [30, 31, 33, 35, 36, 38, 39], growth: 6.6, spend: "4 490 €", maturity: "Stable" },
];

export const MARKET_REGIONS = [
  "Europe",
  "Amérique du Nord",
  "Amérique du Sud",
  "Moyen-Orient",
  "Asie-Pacifique",
];

// ---- Opportunities ----
export const OPPORTUNITIES = [
  {
    id: 1,
    title: "Activer le segment luxe US pour la saison hiver",
    category: "Marché",
    description:
      "La demande américaine sur le segment lodges premium progresse de 24 % sur 90 jours. Fenêtre idéale pour une campagne ciblée avant le pic de réservation.",
    score: 94,
    potential: "+ 320 K€",
    horizon: "4–6 semaines",
    impact: "Élevé",
    confidence: 91,
    tags: ["États-Unis", "Luxe", "Hiver"],
  },
  {
    id: 2,
    title: "Partenariat DMC Émirats sur circuits sur-mesure",
    category: "Partenaire",
    description:
      "Trois DMC compatibles identifiés au Moyen-Orient, avec un panier moyen supérieur de 65 % à votre moyenne. Forte affinité avec vos lodges signature.",
    score: 89,
    potential: "+ 210 K€",
    horizon: "8–10 semaines",
    impact: "Élevé",
    confidence: 86,
    tags: ["Émirats A.U.", "DMC", "Premium"],
  },
  {
    id: 3,
    title: "Optimiser le pricing face aux Alpes suisses",
    category: "Pricing",
    description:
      "Écart tarifaire favorable détecté sur les séjours 5–7 nuits. Un ajustement de +4 % préserverait la compétitivité tout en améliorant la marge.",
    score: 82,
    potential: "+ 95 K€",
    horizon: "2–3 semaines",
    impact: "Moyen",
    confidence: 78,
    tags: ["Pricing", "Europe", "Marge"],
  },
  {
    id: 4,
    title: "Capter la demande émergente indienne",
    category: "Marché",
    description:
      "Le marché indien affiche +31 % de croissance. Faible présence concurrentielle sur votre positionnement — opportunité de first-mover.",
    score: 76,
    potential: "+ 140 K€",
    horizon: "10–12 semaines",
    impact: "Moyen",
    confidence: 71,
    tags: ["Inde", "Émergent", "Acquisition"],
  },
  {
    id: 5,
    title: "Co-marketing avec compagnie aérienne alpine",
    category: "Partenaire",
    description:
      "Alignement des flux passagers avec vos périodes creuses. Une offre packagée vol + lodge lisserait le taux d'occupation d'avril à juin.",
    score: 73,
    potential: "+ 88 K€",
    horizon: "6–8 semaines",
    impact: "Moyen",
    confidence: 74,
    tags: ["Aérien", "Package", "Occupation"],
  },
  {
    id: 6,
    title: "Réactiver les partenaires britanniques dormants",
    category: "Activation",
    description:
      "14 partenaires UK inactifs depuis 6 mois présentent un historique de conversion élevé. Séquence de réengagement recommandée.",
    score: 68,
    potential: "+ 62 K€",
    horizon: "3–4 semaines",
    impact: "Faible",
    confidence: 69,
    tags: ["Royaume-Uni", "Réactivation"],
  },
];

export const OPP_CATEGORIES = ["Marché", "Partenaire", "Pricing", "Activation"];

// ---- Coming soon teasers ----
export const COMING_SOON = {
  "data-hub": {
    title: "Data Hub",
    tagline: "Centralisez et enrichissez vos données touristiques",
    features: [
      "Connecteurs vers vos sources de données (PMS, GDS, web analytics)",
      "Nettoyage et normalisation automatique des flux",
      "Catalogue de datasets sectoriels prêts à l'emploi",
    ],
  },
  partners: {
    title: "Partners",
    tagline: "Développez votre écosystème de partenaires touristiques",
    features: [
      "Annuaire qualifié de DMC, hôtels, transporteurs et offices",
      "Matching intelligent basé sur l'affinité commerciale",
      "Espaces de collaboration et suivi des accords",
    ],
  },
  campaigns: {
    title: "Campaigns",
    tagline: "Activez la demande avec des campagnes orchestrées",
    features: [
      "Création de campagnes multi-canal ciblées par marché",
      "Recommandations de budget et de timing par l'IA",
      "Suivi des performances en temps réel",
    ],
  },
  performance: {
    title: "Performance",
    tagline: "Mesurez l'impact réel de vos actions",
    features: [
      "Tableaux de bord attribution et ROI par canal",
      "Comparaison vs. objectifs et vs. concurrents",
      "Rapports exportables pour vos parties prenantes",
    ],
  },
  "ask-lodge": {
    title: "Ask Lodge",
    tagline: "Votre analyste tourisme augmenté par l'IA",
    features: [
      "Posez vos questions en langage naturel sur vos données",
      "Synthèses et recommandations d'actions instantanées",
      "Génération de briefs marché et de rapports",
    ],
  },
  "gsa-worldwide": {
    title: "GSA Worldwide",
    tagline: "Représentation commerciale à l'échelle mondiale",
    features: [
      "Réseau de General Sales Agents par région",
      "Pilotage centralisé des mandats de représentation",
      "Reporting consolidé multi-marchés",
    ],
  },
  settings: {
    title: "Settings",
    tagline: "Configurez votre espace Lodge & Co",
    features: [
      "Gestion des membres et des rôles",
      "Préférences de destination et de marque",
      "Intégrations, API et sécurité",
    ],
  },
};
